import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { Constantes } from 'app/config/constants';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AccesoService } from '../sistema/acceso.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorHelperService implements HttpInterceptor {

  constructor(
    private _fuseSplashScreenService: FuseSplashScreenService,
    private _accesoService: AccesoService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.urlWithParams.includes('api/Compania/registrarPreEvaluacion')) {
      this._fuseSplashScreenService.show();
      return next.handle(req.clone({ })).pipe(
        finalize(() => {
          this._fuseSplashScreenService.hide();
        }
        )
      );
    }else{
      this._accesoService.asignarHeaders();
      if (req.url.indexOf('Dashboard') == -1) {
        this._fuseSplashScreenService.show();
      }
      if (this._accesoService.usuario.grupoCia == '' || this._accesoService.usuario.grupoCia == null) {
        this._accesoService.usuario.grupoCia = '';
        console.log('No tiene el grupo.');
      }
      return next.handle(req.clone({
        setHeaders: {
          Authorization: Constantes.tipoSeguridad.bearToken + this._accesoService.token,
          GrupoCompania: this._accesoService.usuario.grupoCia,
          CompaniaId: this._accesoService.usuario.companiaId,
          SucursalCompaniaId: this._accesoService.sucursalCompaniaId,
          NombreSucursalCompania: this._accesoService.nombreSucursalCompania,
          Inventario: String(this._accesoService.inventario)
        }
      })).pipe(
        finalize(() => {
          this._fuseSplashScreenService.hide();
        }
        )
      );
    }

  }
}

